/************************************************************************/
/* Custom slide show page fiches			*/
/************************************************************************/


  $("#mySlideShow .thumb").each(function( index ) {
        $(this).on("click", function(){
              var id = $(this).attr('id');
              currentSlide(id);
        });
  });
  $("#mySlideShow .prev").click(function(e) {
        plusSlides(-1)
  });
  $("#mySlideShow .next").click(function(e) {
        plusSlides(1)
  });

  var slideIndex = 1;
  showSlides(slideIndex);

  // Next/previous controls
  function plusSlides(n) {
        showSlides(slideIndex += n);
  }

  // Thumbnail image controls
  function currentSlide(n) {
        showSlides(slideIndex = n);
  }

  function showSlides(n) {
        var i;
        var slides = $(".mySlides");
        var dots = $(".thumb");
        var captionText = $("#caption");
        if (n > slides.length) {slideIndex = 1}
        if (n < 1) {slideIndex = slides.length}
        for (i = 0; i < slides.length; i++) {
            slides[i].style.display = "none";
        }
        for (i = 0; i < dots.length; i++) {
            dots[i].className = dots[i].className.replace(" active", "");
        }
        slides[slideIndex-1].style.display = "block";
        dots[slideIndex-1].className += " active";
        captionText.text(dots[slideIndex-1].alt);
  }
